
export const ga = () => {
    const allow = window.Didomi.getUserConsentStatusForVendor('google')
    console.debug(`Google ga tag manager: ga.js (allowed: ${allow})`);

    var id = 'G-SBSLCX0C5Z'
    if (window.location.host.includes('stage') || window.location.host.includes('local-')) id = 'G-DELOFAKE'
    var src = `${document.location.protocol}//sgtm.delo.si/gtag/js?id=${id}`
    if (window.location.host.includes('stage') || window.location.host.includes('local-')) src = `${document.location.protocol}//www.googletagmanager.com/gtag/js?id=${id}`

    if (!allow) return

    var d = document,
        h = d.getElementsByTagName('head')[0],
        s = d.createElement('script');
    s.type = 'text/javascript'
    s.async = true;
    s.src = src;
    h.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    if (window.location.host.includes('stage') || window.location.host.includes('local-')) {
        gtag('config', id)
    } else {
        gtag('config', id, {
            'server_container_url': `${document.location.protocol}//sgtm.delo.si`
        });
    }
}